export default "__VITE_ASSET__BgH$txnB__"